import React, { useEffect, useState } from 'react';
import { listSites } from '../../api/sitesApi';

const KEY = 'asp_active_site';

export function useActiveSite() {
  const [sites, setSites] = useState([]);
  const [siteId, setSiteIdState] = useState(() => {
    try { return localStorage.getItem(KEY) || ''; } catch { return ''; }
  });
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let alive = true;
    listSites()
      .then((d) => alive && setSites(Array.isArray(d) ? d : d?.items || []))
      .catch(() => {})
      .finally(() => alive && setReady(true));
    return () => { alive = false; };
  }, []);

  const setSiteId = (v) => {
    setSiteIdState(v);
    try { localStorage.setItem(KEY, v); } catch { /* ignore */ }
  };
  return { sites, siteId, setSiteId, ready };
}

export default function SiteSelector({ sites, value, onChange, allowAll = true }) {
  return (
    <select className="sec-select" value={value} onChange={(e) => onChange(e.target.value)}>
      {allowAll && <option value="">All my sites</option>}
      {!allowAll && !value && <option value="">Select a site…</option>}
      {sites.filter((s) => s.activePublicKey).map((s) => (
        <option key={s.id} value={s.activePublicKey}>
          {s.name || s.domain} — {s.domain}
        </option>
      ))}
    </select>
  );
}
